import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const AdminRoute = memo(function AdminRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);
  
  useEffect(() => {
    if (session.status === "unauthorized") {
      navigate("/admin/signin");
      return;
    }
    if (session.status === "authorized" && session?.user?.role === "user") {
      console.log("User from Admin");
      navigate("/dashboard");
      return;
    }
  }, [session.status, navigate, session?.user?.role]);

  if (session.status === "loading") {
    return <LoadingFallback />;
  }

  return session.status === "authorized" && session?.user?.role === "admin"
    ? children
    : null;
});

export default AdminRoute;
